import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import {Row, Button, Card, Modal} from 'antd';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Filter from './UI.List.Filter';
import Table from './UI.List.Table';
import {inputSettlement} from 'src/api'; 

const css = require('./index.scss');
/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    public state: ModulesState = new ModulesState(); 
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const { user } = MyStore.instance.getState();
        const {companyName} = user.userInfo;
        const extraButtons = (
            <div>
                <Button className="mr10" type="primary" onClick={()=>{ModulesAction.handleFinish();}}>匹配完成</Button>
                <Button className="mr10" type="primary" onClick={()=>{ModulesAction.handleSend();}}>批量发送</Button>
                <Button className="mr10" type="default" onClick={()=>{ModulesAction.handleInvalid();}}>批量作废</Button>
                <Button icon="sync"  onClick={()=>{this.refresh();}}>刷新 </Button>
            </div>
        );
        return (
            <div className={css.right}>
                <Card title="进项结算单" extra={extraButtons}>
                    <Row style={{marginBottom: 20}}>
                        <div className="pull-left" style={{paddingTop: 8}}>
                            购方名称: {companyName}
                        </div>
                        <div className="pull-right">
                            <Button 
                                icon="filter"
                                onClick={()=>{this.setState({filterDisplay: !this.state.filterDisplay});}}
                            >
                                筛选
                            </Button>
                        </div>
                    </Row>
                    <Filter filterDisplay={this.state.filterDisplay}/>
                    <Table />
                </Card>
            </div>
        );
    }
    private refresh = () => {
        const { user } = MyStore.instance.getState();
        const {companyId} = user.userInfo;

        ModulesAction.initPaging();
        if (this.modulesState.fields){
            ModulesAction.getList({companyId,pageSize:10, pageNum: this.modulesState.current, ...this.modulesState.fields});
        } else {
            ModulesAction.getList({companyId,pageSize:10, pageNum: this.modulesState.current});
        }
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/UI.Components.tsx